import { App, AutoComplete, Button, Checkbox, Col, Form, Input, InputNumber, List, Row, Select, Tooltip } from 'antd';
import { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import {
  addPmOfferProjectWorkPlaceItem,
  updateEquipmentTab,
  updateField,
} from '../../../../../contextRedux/PMOfferProject/PmOfferModelProject';
import { SearchInput } from '../../../../../customComponents/input/SearchInput';
import { CustomTable } from '../../../../../customComponents/table/CustomTable';
import { RootState } from '../../../../../store';

const { Option } = AutoComplete;

const ProjectAddEquipmentTab: FC<any> = ({}) => {
  const isMobile = useMediaQuery({ maxWidth: 720 });

  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { message } = App.useApp();

  const [searchTerm, setSearchTerm] = useState<string>('');
  const [searchTable, setSearchTable] = useState<string>('');
  const [checkAll, setCheckAll] = useState(false);
  const [indeterminate, setIndeterminate] = useState(false);
  const [searchRecomandationPieceNumber, setRecomandationPieceNumber] = useState<number>(1);

  const [checkAllTehnicians, setCheckAllTehnicians] = useState(false);
  const [indeterminateTehnicians, setIndeterminateTehnicians] = useState(false);

  const [stages, setStages] = useState<any>([]);
  const [newStage, setNewStage] = useState<any>('');

  const pmOffer = useSelector((state: RootState) => state.models?.pmOfferProject);
  const users = useSelector((state: RootState) => state?.store.user.data);
  const systemTypes = useSelector((state: RootState) => state.store.systemType.data);
  const selectedSystemTypeId = useSelector(
    (state: RootState) => state.models?.pmOfferProject.equipmentTab.systemTypeId
  );
  const deviceTypes = useSelector((state: RootState) => state.store.deviceType.data);

  const addedDevices = pmOffer.pmOfferWorkPlaceItems;
  const workPlaces = useSelector((state: RootState) => state.models?.pmOfferProject.company?.workPlaces);
  const agents = useSelector((state: RootState) => state.models?.pmOfferProject.company.contactPersons ?? []);

  const [filtredDeviceTypes, setFiltredDeviceTypes] = useState<any[]>(
    useSelector((state: RootState) =>
      state.store.deviceType.data.filter(
        (d: any) => d.systemTypeId == state.models?.pmOfferProject.equipmentTab.systemTypeId
      )
    )
  );

  const handleAddDevice = async (record: any, isFromWorkPlaceItems: boolean = false) => {
    const locations = pmOffer?.location; // Array of locations in the pmOffer
    const systemType = form.getFieldValue('systemType');
    const agent = form.getFieldValue('agent');
    let isErrorMessageShown = false;
    let isFilteredErrorMessageShown = false; // New flag for filteredAddedDevice
    let isChiefTechnicianErrorShown = false; // New flag for chief technician validation

    for (const location of locations) {
      // Check if the device is already added for this location
      const isDeviceAlreadyAddedForLocation = addedDevices?.some(
        (ad: any) => ad.deviceTypeId === record.id && ad.workPlaceId === location.id
      );

      if (isDeviceAlreadyAddedForLocation) {
        if (!isErrorMessageShown) {
          message.error(<span>{record?.name} este deja adaugat la această locație!</span>);
          isErrorMessageShown = true; // Prevent further error messages for this device
        }
        continue; // Skip this location if the device is already added
      }

      // Check for filteredAddedDevice condition
      const filteredAddedDevice = addedDevices?.filter(
        (ad: any) =>
          ad.workPlace?.name === location?.name &&
          ad.systemType?.name === systemType?.name &&
          ad.interventionPerSystemType !== pmOffer.equipmentTab.interventionPerSystemType &&
          ad.period !== pmOffer.equipmentTab.period
      );

      if (filteredAddedDevice?.length > 0) {
        if (!isFilteredErrorMessageShown) {
          message.error(
            <span>
              Nu puteti adauga alt device pe aceeași locație: <b>{filteredAddedDevice[0]?.workPlace?.name}</b>, cu
              același sistem: <b>{filteredAddedDevice[0].systemType?.name}</b> cu o periodicitate diferită de{' '}
              <b>{filteredAddedDevice[0].period}</b> sau un număr de intervenții diferit de{' '}
              <b>{filteredAddedDevice[0].interventionPerSystemType}</b>
            </span>,
            20
          );
          isFilteredErrorMessageShown = true; // Prevent further error messages for filteredAddedDevice
        }
        continue; // Skip this location if the filtered condition is met
      }

      // NEW VALIDATION: Check if there's already a device with a chief technician for this workplace
      const existingDevicesWithChiefTechnician = addedDevices?.filter(
        (ad: any) =>
          ad.workPlace?.name === location?.name &&
          ad.chiefTehnician &&
          ad.chiefTehnicianId &&
          ad.chiefTehnicianId !== pmOffer.equipmentTab.chiefTehnicianId
      );

      if (existingDevicesWithChiefTechnician?.length > 0 && pmOffer.equipmentTab.chiefTehnicianId) {
        if (!isChiefTechnicianErrorShown) {
          message.error(
            <span>
              Nu puteti adauga un device cu tehnician șef diferit pe aceeași locație: <b>{location?.name}</b>. Tehnician
              șef existent: <b>{existingDevicesWithChiefTechnician[0]?.chiefTehnician?.name}</b>
            </span>,
            10
          );
          isChiefTechnicianErrorShown = true;
        }
        continue; // Skip this location if there's already a device with a different chief technician
      }

      if (isFromWorkPlaceItems) {
        const workPlaceItem = location?.workPlaceItems?.find((wpi: any) => wpi?.deviceTypeId === record?.id);
        const pieceCount = workPlaceItem?.piece ?? 1;

        const deviceData = {
          ...record,
          workPlace: location,
          workPlaceId: location?.id,
          device: { ...record },
          deviceTypeId: record.id,
          agent: agent,
          agentId: agent?.id,
          pmOfferWorkPlaceItemStage: pmOffer.equipmentTab.pmOfferWorkPlaceItemStage,
          pmOfferWorkPlaceItemStageId: pmOffer.equipmentTab.pmOfferWorkPlaceItemStage.id,
          systemType: systemType,
          systemTypeId: systemType?.id,
          pmOfferWorkPlaceItemTehnicians: pmOffer.technician,
          chiefTehnician: pmOffer.equipmentTab.chiefTehnician,
          chiefTehnicianId: pmOffer.equipmentTab.chiefTehnicianId,
          metadata: {
            deviceType: { price: record?.price },
          },
          details: pmOffer.equipmentTab.details,
          unitMeasure: 'buc',
          laborPrice: record?.laborPricePM * pieceCount,
          laborTime: record?.laborTimePM * pieceCount,
          piece: pieceCount,
        };

        dispatch(addPmOfferProjectWorkPlaceItem(deviceData));
      } else {
        form.setFieldsValue({
          ...record,
          details: pmOffer.equipmentTab.details,
          laborTimePMTotal: record?.totalLaborsTimePM,
          laborPricePMTotal: record?.totalLaborsPricePM,
          unitMeasure: 'buc',
          piece: searchRecomandationPieceNumber ?? 1,
        });

        const newItem = {
          id: '',
          offerWorkPlaceId: '',
          workPlace: location,
          workPlaceId: location?.id,
          agent: pmOffer.equipmentTab.agent,
          agentId: pmOffer.equipmentTab.agentId,
          systemType: pmOffer.equipmentTab.systemType,
          systemTypeId: pmOffer.equipmentTab.systemTypeId,
          chiefTehnician: pmOffer.equipmentTab.chiefTehnician,
          chiefTehnicianId: pmOffer.equipmentTab.chiefTehnicianId,
          pmOfferWorkPlaceItemStage: pmOffer.equipmentTab.pmOfferWorkPlaceItemStage,
          pmOfferWorkPlaceItemStageId: pmOffer.equipmentTab.pmOfferWorkPlaceItemStage.id,
          pmOfferWorkPlaceItemTehnicians: pmOffer.technician,
          device: { ...record },
          deviceTypeId: record.id,
          pmOfferWorkPlaceMetadata: {},
          period: pmOffer.equipmentTab.period,
          laborPrice: record.laborPricePM,
          laborTime: record.laborTimePM,
          unitMeasure: record.unitMeasure ?? 'buc',
          isAnotherProvider: record.isAnotherProvider ?? false,
          interventionPerSystemType: pmOffer.equipmentTab.interventionPerSystemType,
          interventionPriceOnRequest: pmOffer.equipmentTab.interventionPriceOnRequest,
          addition: record.addition,
          piece: searchRecomandationPieceNumber ?? 1,
          metadata: { deviceType: { price: record.price } },
          price: Math.round(
            record.price * (searchRecomandationPieceNumber ?? 1) +
              ((record.price * record.addition) / 100) * (searchRecomandationPieceNumber ?? 1)
          ),
          details: pmOffer.equipmentTab.details,
        };

        dispatch(addPmOfferProjectWorkPlaceItem(newItem));
      }
    }

    // Only show success message if at least one device was added (no errors for all locations)
    if (!isErrorMessageShown && !isFilteredErrorMessageShown && !isChiefTechnicianErrorShown) {
      message.success(
        <span>
          <span className='font-weight-bold'>{record?.name}</span> a fost adăugat.
        </span>
      );
    }
  };

  const handleSelectAgent = (value: string) => {
    const agent = agents.find((awp: any) => awp?.name == value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      agent: agent,
    };
    form.setFieldsValue(fieldsValue);
    dispatch(updateEquipmentTab({ field: 'agentId', value: agent?.id ?? null }));
    dispatch(updateEquipmentTab({ field: 'agent', value: agent ?? null }));
  };

  const handleSystemType = (value: string) => {
    const systemType = systemTypes.find((st: any) => st.name == value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      systemType: systemType,
      systemTypeId: systemType?.id,
    };
    form.setFieldsValue(fieldsValue);
    dispatch(updateEquipmentTab({ field: 'systemTypeId', value: systemType?.id ?? null }));
    dispatch(updateEquipmentTab({ field: 'systemType', value: systemType ?? null }));

    setFiltredDeviceTypes(deviceTypes.filter((dt: any) => dt.systemTypeId == systemType.id));
  };

  const handleSelectStage = (value: any) => {
    const pmOfferWorkPlaceItemStage = pmOffer?.equipmentTab?.stages[value];

    if (pmOfferWorkPlaceItemStage) {
      const fieldsValue = {
        ...form.getFieldsValue(true),
        pmOfferWorkPlaceItemStage: pmOfferWorkPlaceItemStage,
        pmOfferWorkPlaceItemStageId: pmOfferWorkPlaceItemStage?.id,
      };
      form.setFieldsValue(fieldsValue);
      dispatch(
        updateEquipmentTab({ field: 'pmOfferWorkPlaceItemStageId', value: pmOfferWorkPlaceItemStage?.id ?? null })
      );
      dispatch(updateEquipmentTab({ field: 'pmOfferWorkPlaceItemStage', value: pmOfferWorkPlaceItemStage ?? null }));
    } else {
      console.error('Stage not found at the given index.');
    }
  };

  const handleAddStage = () => {
    if (newStage.trim() && !stages.some((s: any) => s.name === newStage)) {
      const newStageObj = { id: '', name: newStage };
      const updatedStages = [...stages, newStageObj];

      setStages(updatedStages);

      // Update Redux store
      dispatch(updateEquipmentTab({ field: 'stages', value: updatedStages }));
      dispatch(updateEquipmentTab({ field: 'pmOfferWorkPlaceItemStage', value: newStageObj }));

      setNewStage('');

      const fieldsValue = {
        ...form.getFieldsValue(true),
        pmOfferWorkPlaceItemStage: newStageObj,
      };
      form.setFieldsValue(fieldsValue);
    }
  };

  const handleDeleteStage = (stageToDelete: any) => {
    const updatedStages = stages.filter(
      (pmOfferWorkPlaceItemStage: any) => pmOfferWorkPlaceItemStage.name !== stageToDelete
    );
    setStages(updatedStages);

    // Update Redux store
    dispatch(updateEquipmentTab({ field: 'stages', value: updatedStages }));
  };

  const handleSelectChiefTechnician = (value: string) => {
    const chiefTehnician = users.find((st: any) => st.name == value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      chiefTehnician: chiefTehnician,
      chiefTehnicianId: chiefTehnician?.id,
    };
    form.setFieldsValue(fieldsValue);
    dispatch(updateEquipmentTab({ field: 'chiefTehnicianId', value: chiefTehnician?.id ?? null }));
    dispatch(updateEquipmentTab({ field: 'chiefTehnician', value: chiefTehnician ?? null }));
  };

  const handleTehnicianChange = (value: any) => {
    // Map selected technicians to include the user property
    const selectedTehnicians = users
      .filter((w: any) => value.includes(w.name))
      .map((user: any) => ({
        id: '',
        pmOfferWorkPlaceItemId: '',
        userId: user?.id,
        user: { id: user?.id, name: user?.name }, // Add the user property structure
      }));

    dispatch(updateField({ field: 'technician', value: selectedTehnicians }));
    updateSelectAllTehniciansState(value);
  };

  // Update the handleSelectAllTehniciansChange function
  const handleSelectAllTehniciansChange = (e: any) => {
    const { checked } = e.target;
    const allTehnicians = users.map((user: any) => user.name);

    // Map all technicians to include the user property when selecting all
    const selectedTehnicians = checked
      ? users.map((user: any) => ({
          id: '',
          pmOfferWorkPlaceItemId: '',
          userId: user?.id,
          user: { id: user?.id, name: user?.name }, // Add the user property structure
        }))
      : [];

    dispatch(updateField({ field: 'technician', value: selectedTehnicians }));

    form.setFieldsValue({
      tehnician: { name: checked ? allTehnicians : [] },
    });

    setCheckAllTehnicians(checked);
    setIndeterminateTehnicians(false);
  };

  const updateSelectAllTehniciansState = (selected: any) => {
    if (selected.length === users?.length) {
      setCheckAllTehnicians(true);
      setIndeterminateTehnicians(false);
    } else if (selected.length > 0) {
      setCheckAllTehnicians(false);
      setIndeterminateTehnicians(true);
    } else {
      setCheckAllTehnicians(false);
      setIndeterminateTehnicians(false);
    }
  };

  const handleSearchInDeviceTable = (value: string, recomandationPieceNumber: number) => {
    setSearchTable(value);
    setRecomandationPieceNumber(recomandationPieceNumber);
    const filtered = deviceTypes
      ?.filter((device: any) => device.systemTypeId === selectedSystemTypeId)
      .filter(
        (device: any) =>
          (searchRecomandationPieceNumber >= device?.minRecomandation &&
            searchRecomandationPieceNumber <= device?.maxRecomandation &&
            device.name.toLowerCase().includes(value.toLowerCase())) ||
          device.model.toLowerCase().includes(value.toLowerCase()) ||
          device.producer.toLowerCase().includes(value.toLowerCase()) ||
          device.provider.toLowerCase().includes(value.toLowerCase()) ||
          device.price.toString().toLowerCase().includes(value.toLowerCase()) ||
          device.laborTimeSM.toString().toLowerCase().includes(value.toLowerCase()) ||
          device.laborPriceSM.toString().toLowerCase().includes(value.toLowerCase())
      );

    setFiltredDeviceTypes(filtered);
  };

  const handleSearchTermChange = (value: string) => {
    setSearchTerm(value);
  };

  const handleFilter = (inputValue: string, option: any) => {
    return option.value.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1;
  };

  const handleLocationChange = (value: any) => {
    const selectedLocations = workPlaces.filter((w: any) => value.includes(w.name));
    dispatch(updateField({ field: 'location', value: selectedLocations }));
    updateSelectAllState(value);
  };

  const handleSelectAllChange = (e: any) => {
    const { checked } = e.target;
    const selectedLocations = checked ? workPlaces : [];
    dispatch(updateField({ field: 'location', value: selectedLocations }));

    form.setFieldsValue({
      location: { name: selectedLocations.map((location: any) => location?.name) },
    });

    setCheckAll(checked);
    setIndeterminate(false);
  };

  const updateSelectAllState = (selected: any) => {
    if (selected.length === workPlaces?.length) {
      setCheckAll(true);
      setIndeterminate(false);
    } else if (selected.length > 0) {
      setCheckAll(false);
      setIndeterminate(true);
    } else {
      setCheckAll(false);
      setIndeterminate(false);
    }
  };

  const deviceTableColumns = [
    {
      title: 'Device Id',
      dataIndex: 'id',
      key: 'id',
      hidden: true,
    },
    {
      title: 'System Type Id',
      dataIndex: 'systemTypeId',
      key: 'systemTypeId',
      hidden: true,
    },
    {
      title: 'Imagine',
      dataIndex: 'imageLink',
      key: 'imageLink',
      render: (record: any) =>
        record[0] ? <img src={record[0]} alt='No Image' style={{ width: '100px', height: 'auto' }} /> : 'No image',
    },
    {
      title: 'Denumire',
      dataIndex: 'name',
      key: 'name',
      render: (text: string) => (
        <Tooltip title={text}>
          <div className='ellipsis-cell'>{text}</div>
        </Tooltip>
      ),
    },
    {
      title: 'System Type',
      dataIndex: ['systemType', 'name'],
      key: 'systemTypeName',
      width: 150,
    },
    {
      title: 'Pret',
      dataIndex: 'price',
      key: 'price',
    },
    {
      title: 'Timp Manopera PM (Minute)',
      dataIndex: 'laborTimePM',
      key: 'laborTimePM',
      width: 200,
    },
    {
      title: 'Pret Manopera PM',
      dataIndex: 'laborPricePM',
      key: 'laborPricePM',
      width: 200,
    },
    {
      title: 'Producator',
      dataIndex: 'producer',
      key: 'producer',
    },
    {
      title: 'Furnizor',
      dataIndex: 'provider',
      key: 'provider',
    },
    {
      title: 'Model',
      dataIndex: 'model',
      key: 'model',
    },
    {
      title: 'Actiune',
      dataIndex: '',
      key: 'actions',
      fixed: 'right',
      render: (record: any) => {
        // Check if all required properties exist
        const hasLocation = pmOffer?.location?.length > 0;
        const hasAgent = pmOffer?.equipmentTab?.agentId != null;
        const hasSystemType = pmOffer?.equipmentTab?.systemTypeId != null;
        const hasTechnicians = pmOffer?.technician?.length > 0;
        const hasChiefTechnician = pmOffer?.equipmentTab?.chiefTehnicianId != null;
        const hasStage = pmOffer?.equipmentTab?.pmOfferWorkPlaceItemStage?.id != null;

        return (
          <Button
            onClick={() => handleAddDevice(record)}
            disabled={!(hasLocation && hasAgent && hasSystemType && hasTechnicians && hasChiefTechnician && hasStage)}
            type='primary'
          >
            Adauga
          </Button>
        );
      },
      width: 10,
    },
  ];

  // Card rendering
  const renderCards = (filtredDeviceTypes: any, handleAddDevice: (device: any) => void, pmOfferProject: any) => (
    <div className='cardContainer'>
      {filtredDeviceTypes.map((device: any) => {
        // Check if all required properties exist
        const hasLocation = pmOfferProject?.location?.length > 0;
        const hasAgent = pmOfferProject?.equipmentTab?.agentId != null;
        const hasSystemType = pmOfferProject?.equipmentTab?.systemTypeId != null;
        const hasTechnicians = pmOfferProject?.technician?.length > 0;
        const hasChiefTechnician = pmOfferProject?.equipmentTab?.chiefTehnicianId != null;
        const hasStage = pmOfferProject?.equipmentTab?.pmOfferWorkPlaceItemStage?.id != null;

        return (
          <div className='device-card' key={device.id}>
            <img
              src={device.imageLink && device.imageLink[0] ? device.imageLink[0] : ''}
              alt='Device'
              className='cardImage'
            />
            <div className='cardContent'>
              <p>
                <strong>Denumire:</strong> {device.name}
              </p>
              <p>
                <strong>Model:</strong> {device.model}
              </p>
              <p>
                <strong>Pret:</strong> {device.price}
              </p>
            </div>
            <button
              className='addButton'
              onClick={() => handleAddDevice(device)}
              disabled={!(hasLocation && hasAgent && hasSystemType && hasTechnicians && hasChiefTechnician && hasStage)}
            >
              Adauga
            </button>
          </div>
        );
      })}
    </div>
  );

  // Table rendering
  const renderTable = () => (
    <CustomTable initialDataSource={filtredDeviceTypes} columns={deviceTableColumns} rowKey='id' />
  );

  return (
    <>
      <Form form={form} layout='vertical'>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item
              name={['location', 'name']}
              label='Selectati locatiile'
              rules={[{ required: true, message: 'Alegeti cel putin o locatie!' }]}
            >
              <Select
                mode='multiple'
                allowClear
                placeholder='Selecteaza locatie'
                value={pmOffer.location?.map((loc: any) => loc?.name)} // Ensure the value is an array of strings
                onChange={handleLocationChange}
                filterOption={handleFilter}
              >
                <Option key='select-all' disabled>
                  <Checkbox indeterminate={indeterminate} onChange={handleSelectAllChange} checked={checkAll}>
                    Select All
                  </Checkbox>
                </Option>
                {workPlaces
                  ?.filter((location: any) => location?.name?.toLowerCase()?.includes(searchTerm.toLowerCase()))
                  .map((location: any, index: any) => (
                    <Option key={index} value={location?.name}>
                      {location?.name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item
              name={['agent', 'name']}
              label='Persoana Contact'
              rules={[{ required: true, message: 'Alegeti o persoana de contact!' }]}
            >
              <AutoComplete
                placeholder='Select an agent'
                onSelect={handleSelectAgent}
                onChange={() => handleSearchTermChange}
                filterOption={handleFilter}
                value={searchTerm}
              >
                {agents?.map((a: any, index: any) => (
                  <Option key={index} value={a?.name}>
                    {a?.name} - {a?.role}
                  </Option>
                ))}
              </AutoComplete>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item
              name={['systemType', 'name']}
              label='Tip sistem'
              rules={[{ required: true, message: 'Alegeti un sistem!' }]}
            >
              <AutoComplete
                placeholder='Selectati un sistem'
                onSelect={handleSystemType}
                onChange={() => handleSearchTermChange}
                filterOption={handleFilter}
                value={searchTerm}
              >
                {systemTypes?.map((systemType: any, index: any) => (
                  <Option key={index} value={systemType.name}>
                    {' '}
                    {systemType.name}
                  </Option>
                ))}
              </AutoComplete>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item
              name={['pmOfferWorkPlaceItemStage', 'name']}
              label='Etapa'
              rules={[{ required: true, message: 'Alegeti sau create o etapa!' }]}
            >
              <Select
                placeholder='Selectati sau adaugati o etapa'
                value={pmOffer?.equipmentTab?.pmOfferWorkPlaceItemStage?.name}
                onChange={handleSelectStage}
                style={{ width: '100%' }}
              >
                {stages.map((pmOfferWorkPlaceItemStage: any, index: any) => (
                  <Option key={index} value={index}>
                    {pmOfferWorkPlaceItemStage.name}
                  </Option>
                ))}
              </Select>
              <div style={{ display: 'flex', marginTop: 8 }}>
                <Input
                  value={newStage}
                  onChange={(e) => setNewStage(e.target.value)}
                  placeholder='Adauga etapa'
                  style={{ flex: 1, marginRight: 8 }}
                />
                <Button type='primary' onClick={handleAddStage} disabled={!newStage.trim()}>
                  Adauga
                </Button>
              </div>
              <List
                size='small'
                bordered
                dataSource={stages}
                renderItem={(
                  pmOfferWorkPlaceItemStage: any,
                  index: any // ✅ Use index as key
                ) => (
                  <List.Item
                    actions={[
                      <Button danger size='small' onClick={() => handleDeleteStage(index)}>
                        Sterge
                      </Button>,
                    ]}
                  >
                    {pmOfferWorkPlaceItemStage.name}
                  </List.Item>
                )}
                style={{ marginTop: 10 }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item
              name={['tehnician', 'name']}
              label='Selectati tehnicienii'
              rules={[{ required: true, message: 'Alegeti cel putin un tehnician!' }]}
            >
              <Select
                mode='multiple'
                allowClear
                placeholder='Selectati tehnicienii'
                value={pmOffer.technician?.map((teh: any) => teh?.user?.name)} // Ensure the value is an array of strings
                onChange={handleTehnicianChange}
                filterOption={handleFilter}
                className='add-equipment-select-input'
              >
                <Option key='select-all' disabled>
                  <Checkbox
                    indeterminate={indeterminateTehnicians}
                    onChange={handleSelectAllTehniciansChange}
                    checked={checkAllTehnicians}
                  >
                    Toate
                  </Checkbox>
                </Option>
                {users.map((user: any, index: any) => (
                  <Option key={index} value={user?.name}>
                    {user?.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item
              name={['chiefTechnician', 'name']}
              label='Tehnician sef'
              rules={[{ required: true, message: 'Tehnicianul sef este obligatoriu!' }]}
            >
              <AutoComplete
                placeholder='Selectati un tehnician sef'
                onSelect={handleSelectChiefTechnician}
                onChange={() => handleSearchTermChange}
                filterOption={handleFilter}
                value={searchTerm}
              >
                {users?.map((user: any, index: any) => (
                  <Option key={index} value={user.name}>
                    {' '}
                    {user.name}
                  </Option>
                ))}
              </AutoComplete>
            </Form.Item>
          </Col>
        </Row>

        {deviceTypes?.length > 0 ? (
          <div>
            <div className='add-equipment-search-number-line'>
              <Row gutter={[16, 16]}>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <InputNumber
                    placeholder='Introduceti numarul de bucati'
                    value={searchRecomandationPieceNumber}
                    min={1}
                    onChange={(value) => handleSearchInDeviceTable(searchTable, value ?? 1)}
                    className='add-equipment-number-input'
                  />
                </Col>
                <Col xs={24} sm={24} md={24} lg={12}>
                  <SearchInput
                    placeholder='Search'
                    value={searchTable}
                    onChange={(e) => handleSearchInDeviceTable(e.target.value, searchRecomandationPieceNumber)}
                    style={{ marginBottom: 10, width: '100%' }}
                    autoFocus={true}
                  />
                </Col>
              </Row>
            </div>
            <div>{isMobile ? renderCards(filtredDeviceTypes, handleAddDevice, pmOffer) : renderTable()}</div>
          </div>
        ) : null}
      </Form>
    </>
  );
};

export default ProjectAddEquipmentTab;
